import { ChangeDetectorRef } from '@angular/core';
//#region imports
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModalDirective } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { Subject, Subscription, forkJoin, of } from "rxjs";
import { Icd10ToIcd11 } from '../../services/icd10ToIcd11.service';
import { SpinnerService } from '../../services/spinner.service';
import { BOClinicHistory } from '../../models/BOClinicHistory.model';
import { BOEps } from '../../models/BOEps.model';
import { BOPerson } from '../../models/BOPerson.model';
import { BOPatientInformation } from '../../models/BOPatientInformation.model';
import { Utilities } from '../../common/utilities';
import { BOClinicHistoryObservations } from '../../models/BOClinicHistoryObservations.model';
import { BOItem } from '../../models/BOItem.model';
import { GenderIdentityService } from '../../services/genderIdentity.service';
import { BORemission } from '../../models/BORemission.model';
import { BOIcd10ToIcd11 } from '../../models/BOIcd10ToIcd11.model';
import { MatSelectChange } from '@angular/material/select';
import { RemissionService } from '../../services/remission.service';
import { IdTypeService } from '../../services/idType.service';
import { DatePipe } from '@angular/common';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { BOCompany } from '../../models/BOCompany.model';
import { BloodTypeService } from '../../services/bloodType.service';
import { EpsService } from '../../services/eps.service';
import { ConsultationCauseService } from '../../services/consultationCause.service';
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
//#endregion imports
@Component({
  selector: 'remissionModal',
  templateUrl: './remission.component.html',
  styleUrls: ['./remission.component.scss']
})
export class RemissionComponent implements OnInit, OnDestroy
{
    @ViewChild('remissionModal', { static: true }) modal: ModalDirective;

//#region declarations
    busyData$:Subscription;
    busyInit$: Subscription;
    busyRemission$:Subscription;

    epsList                   : BOEps []=[];
    genderIdentityList        : BOItem[]=[];
    idTypeList                : BOItem[]=[];
    consultationTypeList      : BOItem[]=[];

    ch                        : BOClinicHistory      = new BOClinicHistory();
    patient                   : BOPerson;
    patientInformation        : BOPatientInformation;
    isSaving                  : boolean=false;
    patientName               : string="";
    patientDocumentType       : string="";
    patientDocumentId         : string;
    patientGenderIdentity     : string;
    icd10ToIcd11              : BOIcd10ToIcd11;

    protected _onDestroy = new Subject<void>();

    searchingDisease                  : Boolean = false;

    searchingIcd10ToIcd11             : Boolean = false;
    searchingCei11Agrouped            : Boolean = false;

    selectedGroupCodeIcd11: string | null = null;
    selectedTitleIcd11: string | null = null;
    selectedCodeIcd10: string | null = null;
    selectedTitleIcd10: string | null = null;

    company: BOCompany;
    rem: BORemission= new BORemission();
    stateForm='';

    remissionForm = this._formBuilder.group({
      remissionDay:                      ['', Validators.required],
      epsId:                             ['', Validators.required],
      clinicHistoryId:                   ['', Validators.required],
      patientName:                       ['', Validators.required],
      birthDay:                          ['', Validators.required],
      patientDocumentType:               ['', Validators.required],
      patientDocumentId:                 ['', Validators.required],
      age:                               ['', Validators.required],
      monthBaby:                         ['',],
      genderIdentityId:                  ['', Validators.required],
      address:                           ['', Validators.required],
      cellPhoneNumber:                   ['', Validators.required],
      responsibleForPatient:             ['', Validators.required ],
      relativeType:                      [''],
      responsibleCellPhoneNumber:        [''],
      receptorOrganization:              [''],
      receptorOrganizationService:       [''],
      receptorOrganizationPhone:         [''],
      receptorOrganizationAddress:       [''],
      receptorPersonAuthorizer:          [''],
      receptorPersonAuthorizerPosition:  [''],

      cie10CodeCtrl:                     [null],
      cie10DiseaseNameCtrl:              [null],
      cie11CodeCtrl:                     [null],
      cie11DiseaseNameCtrl:              [null],

      basicReasonRemission:              ['', Validators.required],
      clinicHistorySummary:              ['', Validators.required],
      observations:                      [''  ],
      referringPhysician:                ['', Validators.required],
      registerNumber:                    ['', ],
      rethus:                            ['', ],

    });
//#endregion declarations

  constructor(  public   _toastr                     : ToastrService,
                private _formBuilder                 : FormBuilder,
                private _icd10ToIcd11Service         : Icd10ToIcd11,
                private _genderIdentityService       : GenderIdentityService,
                private _spinnerService              : SpinnerService,
                private _remissionService            : RemissionService,
                private _idTypeService               : IdTypeService,
                private _consultationCaseService     : ConsultationCauseService,
                private _datePipe                    : DatePipe,
                private _cdr                         : ChangeDetectorRef,
              )
              { }


  ngOnInit(): void {

  }

  openModal(clinicHistory: BOClinicHistory,
            eps:BOEps[],
            patient:BOPerson,
            patientInformation:BOPatientInformation, company:BOCompany, state:string, origen?:string, remission?:BORemission): void
  {
      console.log("En remissionComponente Entra en openModal ch es:", clinicHistory, " patient es: ", patient, "  patientInformation es:", patientInformation, ' y remission es:', remission);
      this._spinnerService.show();

      this.ch=clinicHistory;
      this.patient=patient;
      this.patientInformation=patientInformation;
      this.epsList=eps;
      this.patientName= Utilities.getNameFromPerson(this.patient);
      this.patientDocumentType=patient.idType;
      this.patientDocumentId=patient.personId;
      this.patientGenderIdentity=patientInformation.sexType;
      this.company=company;
      this.rem=remission;


console.log("Después de fillRemision, epsId es:", this.patientInformation.epsId);
//
let dataIcd10:string="";

if(origen=="ch")
{
  console.log("EN REMISION OPENMODAL ORIGEN ES:", origen);
  dataIcd10=clinicHistory.cei10;
    console.log("EN REMISION OPENMODAL ORIGEN CH, dataIcd10 ", dataIcd10);

}

else
{
  console.log("En OPENMODAL DE REMISSIONcoMPONENT, this.rem.cie10CodeCtrl es:",this.rem.cie10CodeCtrl );

  dataIcd10=this.rem.cie10CodeCtrl;
}

console.log("En OPENMODAL DE REMISSIONcoMPONENT, dataIcd10 es:", dataIcd10 );

if(dataIcd10.length > 0)
{
    this.busyData$ = forkJoin
    (
        {
              resultGenderIdentityList         : this._genderIdentityService.getAll(),
              resultIcd10ToIcd11               : this._icd10ToIcd11Service.getIcd10ToIcd11(dataIcd10),
              resultIdTypeService              : this._idTypeService.getAll(),
              resultConsultationTypeService    : this._consultationCaseService.getAll(),
        }
        ).subscribe((
          {

                resultGenderIdentityList,
                resultIcd10ToIcd11,
                resultIdTypeService,
                resultConsultationTypeService,
          }
          )=>
                {

                  this.genderIdentityList=resultGenderIdentityList;
                  this.icd10ToIcd11=resultIcd10ToIcd11;
                  this.idTypeList=resultIdTypeService;
                  this.consultationTypeList=resultConsultationTypeService;

                  console.log('this.idTypeList es:', this.idTypeList);
                                console.log('this.genderIdentityList es:', this.genderIdentityList);

                    this.remissionForm.patchValue({
                    cie10CodeCtrl: this.icd10ToIcd11.codeIcd10?? '',
                    cie10DiseaseNameCtrl: this.icd10ToIcd11.titleIcd10Spanish?? '',
                    cie11CodeCtrl: this.icd10ToIcd11.codeIcd11?? '',
                    cie11DiseaseNameCtrl: this.icd10ToIcd11.titleIcd11Spanish?? ''
                  })
                  this.fillRemission(state, this.rem);

                  this.modal.config = { backdrop: "static", keyboard: false };
                  this.modal.show();
                  this._spinnerService.hide();

                  }

          )

  }
  else
  {
    this.busyData$ = forkJoin
    (
        {
              resultGenderIdentityList         : this._genderIdentityService.getAll(),
             // resultIcd10ToIcd11               : this._icd10ToIcd11Service.getIcd10ToIcd11(dataIcd10),
              resultIdTypeService              : this._idTypeService.getAll(),
              resultConsultationTypeService    : this._consultationCaseService.getAll(),
        }
        ).subscribe((
          {

                resultGenderIdentityList,
               // resultIcd10ToIcd11,
                resultIdTypeService,
                resultConsultationTypeService,
          }
          )=>
                {

                  this.genderIdentityList=resultGenderIdentityList;
                  //this.icd10ToIcd11=resultIcd10ToIcd11;
                  this.idTypeList=resultIdTypeService;
                  this.consultationTypeList=resultConsultationTypeService;

                  console.log('this.idTypeList es:', this.idTypeList);
                                console.log('this.genderIdentityList es:', this.genderIdentityList);

                  this.remissionForm.patchValue({
                    // cie10CodeCtrl: this.icd10ToIcd11.codeIcd10?? '',
                    // cie10DiseaseNameCtrl: this.icd10ToIcd11.titleIcd10Spanish?? '',
                    // cie11CodeCtrl: this.icd10ToIcd11.codeIcd11?? '',
                    // cie11DiseaseNameCtrl: this.icd10ToIcd11.titleIcd11Spanish?? ''

                    cie10CodeCtrl: '',
                    cie10DiseaseNameCtrl: '',
                    cie11CodeCtrl:  '',
                    cie11DiseaseNameCtrl:''

                  })
                  this.fillRemission(state, this.rem);

                  this.modal.config = { backdrop: "static", keyboard: false };
                  this.modal.show();
                  this._spinnerService.hide();

                }

        )
  }




}

  fillRemission(state: string, remission?: BORemission):void
  {


  //console.log("En fileRemission, baby age es:", babyAge);
    this.stateForm=state;
    this._cdr.detectChanges();

  console.log("En fileRemission, stateForm es:", this.stateForm);
    console.log("En fileRemission, patient es:", this.patient);


    if(state=='create')
    {
        let babyAge:string;
        let ageT=this.patient.birthDate;
        babyAge=Utilities. getBabyAgeAsString(ageT);

        let idTypeTemp= this.idTypeList.find(x=>x.code==this.patient.idType).id;
        let conCause= this.consultationTypeList.find(x=>x.code==this.ch.consultationCause).name;
      this.remissionForm.patchValue({
        remissionDay: Date.now(),
        epsId:this.patientInformation.epsId,
        clinicHistoryId:this.ch.id,
        patientName:this.patientName,
        birthDay: this.patient.birthDate,
     //   patientDocumentType: this.patient.idType,
        patientDocumentType: idTypeTemp,
        patientDocumentId:this.patient.personId,
        age: Utilities.calculateAge(this.patient.birthDate),
        monthBaby:babyAge,
        genderIdentityId: parseInt(this.patientInformation.genderIdentity),

        address:this.patient.address,
        cellPhoneNumber: this.patient.cellPhoneNumber,
        responsibleForPatient:this.patient.emergencyContactName,
        relativeType:'',
        responsibleCellPhoneNumber:this.patient.emergencyContact,
        receptorOrganizationAddress: '',

        receptorOrganization:'',
        receptorOrganizationService:'',
        receptorOrganizationPhone:null,
        receptorPersonAuthorizer:'',
        receptorPersonAuthorizerPosition:'',
        basicReasonRemission:'',
      //  clinicHistorySummary: 'Motivo de consulta:' + this.ch.consultationCause +'\n'+'Antecedentes Patológicos:'+ this.ch.pathologicalRecord +'\n Anamnesis:'+this.ch.anamnesis,
        clinicHistorySummary: 'Motivo de consulta:' + conCause +'\n'+'Antecedentes Patológicos:'+ this.ch.pathologicalRecord +'\n Anamnesis:'+this.ch.anamnesis,

        observations:this.getObservations(this.ch.clinicHistoryObservations),
        referringPhysician              : '',
        registerNumber                  : '',

      })
        this.modal.config = { backdrop: "static", keyboard: false };
        this.modal.show();
        this._spinnerService.hide();



    }
    else{
      console.log('Entra al else de fillRemission. stateForm es:', this.stateForm);
        let babyAge:string;

        let ageT=this.rem.birthDay;
        console.log("En EDICION remission es:", this);
        babyAge=Utilities. getBabyAgeAsString(ageT);


            this.remissionForm.patchValue({
              remissionDay          : this.rem.remissionDay,
              epsId                 : this.rem.epsId,
              clinicHistoryId       : this.rem.clinicHistoryId,
              patientName           : this.rem.patientName,
              birthDay              : this.rem.birthDay,
              patientDocumentType   : this.rem.patientDocumentType,
              patientDocumentId     : this.rem.patientDocumentId,
              age                   : Utilities.calculateAge(this.rem.birthDay),
              monthBaby             : babyAge,
            // genderIdentityId: Utilities.getGenderIdentityName(parseInt(this.patientInformation.genderIdentity), this.genderIdentityList),
              genderIdentityId      : this.rem.genderIdentityId,
              address                : this.rem.address,

              cellPhoneNumber       : this.rem.cellPhoneNumber,
              responsibleForPatient : this.rem.responsibleForPatient,
              relativeType          : this.rem.relativeType,
              responsibleCellPhoneNumber  : this.rem.responsibleCellPhoneNumber,
              receptorOrganization        : this.rem.receptorOrganization,
              receptorOrganizationService : this.rem.receptorOrganizationService,
              receptorOrganizationAddress      : this.rem.receptorOrganizationAddress,
              receptorOrganizationPhone   : this.rem.receptorOrganizationPhone,
              receptorPersonAuthorizer    : this.rem.receptorPersonAuthorizer,
              receptorPersonAuthorizerPosition: this.rem.receptorPersonAuthorizerPosition,
              basicReasonRemission            : this.rem.basicReasonRemission,
              clinicHistorySummary            : this.rem.clinicHistorySummary,
              observations                    : this.rem.observations,
              referringPhysician              : this.rem.referringPhysician,
              registerNumber                  : this.rem.registerNumber
            });
            this._cdr.detectChanges();
            this.modal.config = { backdrop: "static", keyboard: false };
            this.modal.show();
            this._spinnerService.hide();



    }


  }


  saveRemission():void{
    console.log("Entra a saveRemission");

    let dayTemp=this.remissionForm.get('remissionDay').value;
    let birthdayTemp=this.remissionForm.get('birthDay').value;
    let birthdayTypo=typeof birthdayTemp;
    let birthdayLast=new Date();
    console.log("dayTemp-remissionDay es:", dayTemp, " y su tipo es :", typeof dayTemp);
    console.log("birthDay es:", birthdayTemp, " y su tipo es es:", birthdayTemp);

    if(birthdayTypo=="string" )
    { birthdayLast= new Date(birthdayTemp);}
    else{
      birthdayLast=this.remissionForm.get('birthDay').value;
    }


  let rem = new BORemission();

  const remissionDayValue = this.remissionForm.get('remissionDay').value;
  const birthDayValue = this.remissionForm.get('birthDay').value;


    console.log("birthDayValue es:", birthDayValue, " y su tipo es:", typeof birthDayValue);
    console.log("remissionValue es:", remissionDayValue, " y su tipo es:", typeof remissionDayValue);
    console.log("Valor de DoctType antes de temp es:", this.remissionForm.get('patientDocumentType')!.value);
    let docTypeTemp=parseInt(this.remissionForm.get('patientDocumentType')!.value);
    console.log("Valor de doctTypeTemp es:", docTypeTemp);

    rem.remissionDay=remissionDayValue instanceof Date ? remissionDayValue : null;

    rem.epsId=this.toNumber((this.remissionForm.get('epsId').value));
    rem.clinicHistoryId=this.toNumber((this.remissionForm.get('clinicHistoryId').value));
    rem.patientName=this.remissionForm.get('patientName').value;
    //rem.birthDay=birthDayValue instanceof Date ? birthDayValue : null;
    rem.birthDay=birthdayLast;


   // rem.patientDocumentType=this.idTypeList.find(x=>x.code==this.remissionForm.get('patientDocumentType')!.value).id;
    rem.patientDocumentType=docTypeTemp;
    rem.patientDocumentId=this.remissionForm.get('patientDocumentId').value;

    rem.age=this.toNumber((this.remissionForm.get('age').value));
      rem.babyMonths=this.remissionForm.get('monthBaby').value;

   // rem.genderIdentityId=this.toNumber((this.remissionForm.get('genderIdentityId').value));
    rem.genderIdentityId=this.remissionForm.get('genderIdentityId').value;

    rem.address=this.remissionForm.get('address').value;
    rem.cellPhoneNumber=this.remissionForm.get('cellPhoneNumber').value;
    rem.responsibleForPatient= this.remissionForm.get('responsibleForPatient').value;
    rem.relativeType=this.remissionForm.get('relativeType').value;
    rem.responsibleCellPhoneNumber=this.remissionForm.get('responsibleCellPhoneNumber').value;

    rem.receptorOrganization=this.remissionForm.get('receptorOrganization').value;
    rem.receptorOrganizationAddress=this.remissionForm.get('receptorOrganizationAddress').value;
    rem.receptorOrganizationService=this.remissionForm.get('receptorOrganizationService').value;
    rem.receptorOrganizationPhone=this.remissionForm.get('receptorOrganizationPhone').value;
    rem.receptorPersonAuthorizer=this.remissionForm.get('receptorPersonAuthorizer').value;
    rem.receptorPersonAuthorizerPosition=this.remissionForm.get('receptorPersonAuthorizerPosition').value;

  // TODO rem.cie11Diagnostic=this.remissionForm.get('cie11Diagnostic').value;

  rem.cie10CodeCtrl=this.remissionForm.get('cie10CodeCtrl').value;
  rem.cie10DiseaseNameCtrl=this.remissionForm.get('cie10DiseaseNameCtrl').value;
  rem.cie11CodeCtrl=this.remissionForm.get('cie11CodeCtrl').value;
  rem.cie11DiseaseNameCtrl=this.remissionForm.get('cie11DiseaseNameCtrl').value;

    rem.basicReasonRemission=this.remissionForm.get('basicReasonRemission').value;
    rem.clinicHistorySummary=this.remissionForm.get('clinicHistorySummary').value;
    rem.observations=this.remissionForm.get('observations').value;

    rem.referringPhysician=this.remissionForm.get('referringPhysician').value;
    rem.registerNumber=this.remissionForm.get('registerNumber').value;
    rem.rethus=this.remissionForm.get('rethus').value;

    this.isSaving=true;

    console.log("En saveRemision, rem enviada es:", rem);

    this._remissionService.saveRemission(rem).subscribe(data=>{

      if(data==1 || data==2) this._toastr.success("Éxito", "Ha guardado la remission");
      else this._toastr.error("Fallo", "mensaje es:"+data.toString());
      this.isSaving=false;
    });

    this.isSaving=false;


  }

  getObservations(obs:BOClinicHistoryObservations[]):string
  {
    let result="";
    if(obs.length>0)
    {
      obs.forEach(x=>{
        result=result+ x.observation+ '\n';
      })

    }
    return result;

  }

  onSelectCei11Item(event: MatSelectChange): void {
    const selected = event.value;

    if (selected && selected.group && selected.item) {
      this.selectedGroupCodeIcd11 = selected.group.key;
      this.selectedTitleIcd11 = selected.group.listCei10ToCei11[0]?.titleIcd11Spanish || '';
      this.selectedCodeIcd10 = selected.item.codeIcd10;
      this.selectedTitleIcd10 = selected.item.titleIcd10Spanish;

      console.log('CEI11 Grupo:', this.selectedGroupCodeIcd11);
      console.log('CEI11 Título:', this.selectedTitleIcd11);
      console.log('CEI10 Código:', this.selectedCodeIcd10);
      console.log('CEI10 Título:', this.selectedTitleIcd10);
    }
  }
  //
  ngOnDestroy(): void
  {
    if (this.busyData$) {
          this.busyData$.unsubscribe();
      }

    if (this.busyInit$) {
          this.busyInit$.unsubscribe();
      }

    if (this.busyRemission$) {
          this.busyRemission$.unsubscribe();
      }

    //this.busyData$.unsubscribe();
  }

  private toNumber(value: any): number | null {
    const num = parseInt(value, 10);
    return isNaN(num) ? null : num;
  }

  close():void{
    this.remissionForm.reset();
    this.ch=null;
    this.patient=null;
    this.patientInformation=null;
    this.modal.hide();
  }

  onDateChange(event: any)
  {
    const fecha = event.value;

    console.log('Entra a onDateChange,Tipo:', typeof fecha);
    console.log('Valor:', fecha);

    // Asegurar que siempre sea Date
    if (fecha && !(fecha instanceof Date))
    {
          const tempDay=new Date(fecha)
          console.log("tempDay es:", tempDay);

      this.remissionForm.patchValue({
//        birthDay: new Date(fecha)
        remissionDay: new Date(fecha)

      });


      this._cdr.detectChanges();
    }

        if (fecha && (fecha instanceof Date))
    {
          const tempDay=new Date(fecha)
          console.log("tempDay es:", tempDay);

      this.remissionForm.patchValue({
//        birthDay: new Date(fecha)
        remissionDay: fecha

      });


      this._cdr.detectChanges();
    }


  }

  onDateString(data: string)
  {
    const fecha = data;


    console.log('Entra a onDateChange,Tipo:', typeof fecha);
    console.log('Valor:', fecha);
  let temp=Utilities.convertStringToDate(fecha);
    // Asegurar que siempre sea Date
      this.remissionForm.patchValue({
        birthDay: temp
      });

  }

//#region print

  generatePDF()
  {
      const documentDefinition = this.getDocumentDefinition();
      pdfMake.createPdf(documentDefinition).open();
  }

  getDocumentDefinition()
  {
      let dateBasic= this.remissionForm.get('remissionDay').value;
      console.log("dateBasic es:", dateBasic, " y su tipo es:", typeof dateBasic);
      const dateObj= new Date(dateBasic);
      let dateTemp=this._datePipe.transform(dateObj, 'dd /MM/YYYY');
      let hourTemp = this._datePipe.transform(dateObj, 'HH:mm');
      let genderId=this.remissionForm.get('genderIdentityId').value;
      let genderIdentityName=this.genderIdentityList.find(x=>x.id==genderId).name;
      // let dateTemp=this._datePipe.transform(Date.now(), 'dd /MM/YYYY');
      // let hourTemp = this._datePipe.transform(Date.now(), 'HH:mm');
      let dayTemp='';
      if(this.stateForm=='edi') dateTemp=this._datePipe.transform(this.rem.remissionDay), 'dd /MM/YYYY';
      const logoshort='data:image/png;base64,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';

        return {
          pageSize: 'A4',
          pageMargins: [10, 120, 20, 30],

          header:[
                //logo-dirección
                {
                  columns:
                  [
                    //logo
                    {
                      margin: [35, 0, 0, 0],
                      image: logoshort +',', alignment: 'center', width: 200, height:74,
                    },
                    //blank space
                    {
                      fontSize:10,
                      text:
                      [
                        // {text:'Calle 5 Oeste Nª D-50-03\n' },
                      ],
                      margin: [15, 25, 0, 0],
                      width: '30%'
                    },
                      // Dirección
                    {

                      fontSize:10,
                      text:
                      [
                        {text:'Calle 5 Oeste Nª D-50-03\n' },
                        {text:'B/El Cortijo -Cali- Valle-Colombia\n' },
                        {text:'Telf: 316 4071420\n' },
                      ],
                      margin: [15, 25, 0, 0],
                      width: '30%'

                    },
                  ]
                },
                // company.nit
                {
                  fontSize: 10,
                  columns:
                  [
                      {
                          text: 'NIT '+ this.company.nit,
                          margin: [35, 0, 0, 0],
                          width: '50%'
                      }
                  ]
                },
                // company.email - pagina web

                {
                  fontSize: 10,
                  columns: [
                      {
                          text: this.company.email,
                          width: '40%',
                          margin: [35, 0, 0,0],
                          alignment: 'left',


                      },
                      {
                        text:'',
                        width: '5%',
                        margin: [15, 0, 0, 5],

                      },
                      {
                        text: 'www.servivitalcentromedico.com.co',
                        margin: [0, 0, -50, 5],
                          alignment: 'right',
                        width: '40%'
                    },


                  ]
              },

          ],



          content:
          [
            {
              margin: [20, 0, 20, 40],   // left, top, right, bottom
              stack:
              [

        //   #region title: REMISIÓN
                {
                  columns:
                  [
                    {
                      fontSize:10,
                      text:
                      [

                      ],
                      margin: [15, 10, 15, 0],
                      width: '20%'
                    },
                    {
                      fontSize:18,
                      text:
                      [
                        {text:'REMISIÓN DE PACIENTE' },

                      ],
                      margin: [25, 10, 15, 0],
                      alignment: 'center',
                      width: '60%'
                    },

                    {

                      fontSize:10,
                      text:
                      [

                      ],
                      margin: [15, 10, 15, 0],
                      width: '20%'

                    },

                  ]
                },
 //#endregion title: Historia Odontológica

              //  space
                { text: ' ', margin: [0, 0, 0, 4] },

                { //Obj 1 Datos Fecha -Profesional - No. HC
                      columns:
                      [

                        {
                          fontSize: 10,
                          table:
                          {
                            widths: [80,80,80,80,80,80],
                            body:
                            [
                                [ //row 1: FECHA-HORA-No. HC

                                  //FECHA
                                  {

                                    colSpan:2,
                                    text:
                                        [
                                            {text:'FECHA:', bold:true },dateTemp,

                                        ]
                                  },
                                  {},
                                 //HORA
                                  {

                                    text:
                                        [
                                            {text:'HORA:', bold:true }, hourTemp,

                                        ]
                                  },
                                  //Número HC
                                  {
                                    colSpan:3,
                                    fontSize: 12,
                                    text:
                                        [
                                          {text:'HISTORIA CLÍNICA:', bold:true },
                                          {text: this.ch.id}

                                        ]
                                  },
                                  {},{},


                                ], //end row1

                            ],
                          }
                        }, //End columns

                      ]

                }, //End obj1

                { text: ' ', margin: [0, 0, 0, 4] },


                { //obj2 DATOS PERSONALES -inicia la tabla
                      columns:
                      [
                        //First Column
                        {
                          fontSize: 10,
                          table:
                          {
                          // widths: [80,80,80,80,80,80],
                            widths: [80,80,80,80,80,80],

                            body:
                            [

                                [ //row 0 DATOS PERSONALES

                                {
                                  colSpan: 6,
                                  fillColor: '#FFF', // Color azul (puedes cambiar el código HEX)
                                  color: '#000', // Color blanco
                                  text: [
                                    { text: 'A. DATOS PERSONALES', bold: true }
                                  ]
                                },
                                {},{},{},{},{}
                                ], //end row1

                                [ //row 1 Nombres-PrimerApellido-SegundoApellido-
                                  //Nombres
                                  {
                                    colSpan:2,

                                    text:[
                                            {text:'NOMBRE:\n', bold:true},
                                            {text: this.patient.firstName+" " +this.patient.secondName}
                                        ]
                                  },
                                  {},
                                  //Primer apellido
                                  {

                                    colSpan:2,
                                    text:
                                        [
                                            {text:'PRIMER APELLIDO:\n', bold:true},
                                            {text: this.patient.firtsSurName}

                                        ]
                                  },
                                  {},
                                  //Segundo apellido
                                  {
                                    colSpan:2,

                                    text:
                                        [
                                          {text:'SEGUNDO APELLIDO:\n', bold:true },
                                          {text: this.patient.secondSurName}

                                        ]
                                  },
                                  {},


                                ], //end row1

                                [ //row 2 FecHaNacimiento-Sexo-FechaIngreso
                                  //FECHA DE NACIMIENTO
                                  {
                                    //
                                    colSpan:2,
                                      text:[
                                        {text:'FECHA NACIMIENTO:\n', bold:true},
                                        {text: Utilities.convertDateToString(this.patient.birthDate)}
                                      ]

                                  },
                                  {},

                                  //EDAD
                                  {
                                      text:[
                                        {text:'EDAD AÑOS:\n', bold:true},
                                        {text: Utilities.calculateAge(this.patient.birthDate)}
                                      ]
                                  },
                                  //EDAD BEBE
                                  {
                                      text:[
                                        {text:'MESES:\n', bold:true},
                                        {text: Utilities.getBabyAgeAsString(this.patient.birthDate)}
                                      ]
                                  },
                                  //SEXO
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'SEXO:\n', bold:true},
                                        //{text:this.genderIdentityList.find(x => x.code == this.remissionForm.get('genderIdentity').value, bold:true},{text:'\n'},
                                        {text:genderIdentityName, bold:true},{text:'\n'},

                                      ]
                                  },
                                  {},


                                ], //end row2
                                [ //row 3 Tipo documento - No. Documento
                                  //Tipo documento
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'TIPO DOCUMENTO: \n', bold:true},
                                        {text:this.idTypeList.find(x => x.code == this.patient.idType).name, bold:true},{text:'\n'},
                                      ]

                                  },{},{},
                                  //EMAIL
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'NUMERO:\n', bold:true},
                                        {text: ''},{text: this.patient.personId}
                                      ]
                                  },{},{},

                                ], //end row3

                                [ //row 4 Dirección-Teléfono

                                  //DIRECCIÓN
                                  {
                                    colSpan:4,
                                      text:[
                                        {text:'DIRECCIÓN:\n', bold:true},
                                        {text: this.patient.address}
                                      ]
                                  }, {},{},{},
                                  //TELÉFONO
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'No. TELÉFONO:\n', bold:true},
                                        {text: this.patient.cellPhoneNumber}
                                      ]
                                  },
                                  {},

                                ], //end row4

                                [ //row 5 EPS

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'EPS:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                        {text:this.epsList.find(x => x.id == this.patientInformation.epsId).name, bold:true},{text:'\n'},

                                        ]

                                    },{},{},{},{},{},
                                ], //end row 5

                                [ //row 6 Responsable-Parentesco-telefono
                                  //RESPONSABLE
                                  {
                                    colSpan:3,
                                      text:[
                                        {text:'RESPONSABLE DEL PACIENTE: \n', bold:true},
                                        {text:this.remissionForm.get('responsibleForPatient')!.value, bold:true},{text:'\n'},
                                      ]

                                  },{},{},
                                  //PARENTESCO
                                  {
                                      text:[
                                        {text:'PARENTESCO: \n', bold:true},
                                        {text:this.remissionForm.get('relativeType')!.value, bold:true},{text:'\n'},
                                      ]

                                  },
                                  //TELÉFONO RESPONSABLE

                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'TELÉFONO:\n', bold:true},
                                        {text:this.remissionForm.get('responsibleCellPhoneNumber')!.value, bold:true},{text:'\n'},
                                      ]
                                  },{},

                                ], //end row6

                                [ //row Title: 7 B.ENTIDAD RECEPTORA

                                {
                                  colSpan: 6,
                                  fillColor: '#FFF', // Color azul (puedes cambiar el código HEX)
                                  color: '#000', // Color blanco
                                  text: [
                                    { text: 'B. ENTIDAD RECEPTORA', bold: true }
                                  ]
                                },
                                {},{},{},{},{}
                                ], //end row1

                                [ //row 8 Remitido a - Servicio

                                  //REMITIDO A
                                  {
                                    colSpan:4,
                                      text:[
                                        {text:'EMITIDO A INSTITUCIÓN:\n', bold:true},
                                        {text:this.remissionForm.get('receptorOrganization')!.value, bold:true},{text:'\n'},
                                      ]
                                  }, {},{},{},
                                  //SERVICIO
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'SERVICIO:\n', bold:true},
                                        {text:this.remissionForm.get('receptorOrganizationService')!.value, bold:true},{text:'\n'},
                                      ]
                                  },
                                  {},

                                ], //end row8

                                [ //row 9 Dirección entida receptora-Teléfono

                                  //DIRECCIÓN
                                  {
                                    colSpan:4,
                                      text:[
                                        {text:'DIRECCIÓN:\n', bold:true},
                                        {text:this.remissionForm.get('receptorOrganizationAddress')!.value, bold:true},{text:'\n'},
                                      ]
                                  }, {},{},{},
                                  //TELÉFONO
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'No. TELÉFONO:\n', bold:true},
                                        {text:this.remissionForm.get('receptorOrganizationPhone')!.value, bold:true},{text:'\n'},
                                      ]
                                  },
                                  {},

                                ], //end row9

                                [ //row 10 Persona que autoriza recepción del paciente- Cargo

                                  //PERSONA QUE AUTORIZA LA RECEPCIÓN DEL PACIENTE
                                  {
                                    colSpan:4,
                                      text:[
                                        {text:'PERSONA QUE AUTORIZA LA RECEPCIÓN DEL PACIENTE:\n', bold:true},
                                        {text:this.remissionForm.get('receptorPersonAuthorizer')!.value, bold:true},{text:'\n'},
                                      ]
                                  }, {},{},{},
                                  //CARGO
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'CARGO:\n', bold:true},
                                        {text:this.remissionForm.get('receptorPersonAuthorizerPosition')!.value, bold:true},{text:'\n'},
                                      ]
                                  },
                                  {},

                                ], //end row10

                                [ //row Title: 11 C.DIAGNÓSTICO PACIENTE

                                {
                                  colSpan: 6,
                                  fillColor: '#FFF', // Color azul (puedes cambiar el código HEX)
                                  color: '#000', // Color blanco
                                  text: [
                                    { text: 'C.DIAGNÓSTICO PACIENTE', bold: true }
                                  ]
                                },
                                {},{},{},{},{}
                                ], //end row11

                                [ //row 12 CIE10:Código - CEI10:Descripción

                                  //CIE10:Código
                                  {
                                      text:[
                                        {text:'CÓDIGO CIE10:\n', bold:true},
                                        {text:this.remissionForm.get('cie10CodeCtrl')!.value, bold:true},{text:'\n'},
                                      ]
                                  },
                                  //Descripción
                                  {
                                    colSpan:5,
                                      text:[
                                        {text:'DESCRIPCIÓN:', bold:true},
                                        {text:this.remissionForm.get('cie10DiseaseNameCtrl')!.value, bold:true},{text:'\n'},
                                      ]
                                  },
                                  {},{},{},{},

                                ], //end row12

                                [ //row 13 CIE11:Código - CEI11:Descripción

                                  //CIE11:Código
                                  {
                                      text:[
                                        {text:'CÓDIGO CIE11:\n', bold:true},
                                        {text:this.remissionForm.get('cie11CodeCtrl')!.value, bold:true},{text:'\n'},
                                      ]
                                  },
                                  //Descripción
                                  {
                                    colSpan:5,
                                      text:[
                                        {text:'DESCRIPCIÓN:', bold:true},
                                        {text:this.remissionForm.get('cie11DiseaseNameCtrl')!.value, bold:true},{text:'\n'},
                                      ]
                                  },
                                  {},{},{},{},

                                ], //end row1 13

                                [ //row 14 Causa Básica de Remisión

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'CAUSA BÁSICA DE REMISIÓN :\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                        {text:this.remissionForm.get('basicReasonRemission')!.value, bold:true},{text:'\n'},
                                        ]

                                    },{},{},{},{},{},
                                ], //end row 14

                                [ //row 15 Resumen historia clínica

                                    {
                                      //
                                      colSpan:6,
                                        text:[
                                          {text:'RESUMEN HISTORIA CLÍNICA:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                        {text:this.remissionForm.get('clinicHistorySummary')!.value, bold:true},{text:'\n'},
                                        ]

                                    },{},{},{},{},{},
                                ], //end row 15

                                [ //row 16 Observaciones

                                    {
                                      //OBSERVACIONES
                                      colSpan:6,
                                        text:[
                                          {text:'OBSERVACIONES:\n', bold:true},
                                          //{text: this.patientInformation.epsId}
                                        {text:this.remissionForm.get('observations')!.value, bold:true},{text:'\n'},
                                        ]

                                    },{},{},{},{},{},
                                ], //end row 16

                                [ //row 17 Médico que remite - Registro No. - Firma
                                  //MÉDICO QUE REMITE
                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'MÉDICO QUE REMITE: \n', bold:true},
                                        {text:this.remissionForm.get('referringPhysician')!.value, bold:true},{text:'\n'},
                                      ]

                                  },{},
                                  //REGISTRO No.
                                  {
                                      colSpan:2,
                                      text:[
                                        {text:'REGISTRO No.:\n', bold:true},
                                        {text:this.remissionForm.get('registerNumber')!.value, bold:true},{text:'\n'},
                                      ]

                                  },{},
                                  //FIRMA Y SELLO

                                  {
                                    colSpan:2,
                                      text:[
                                        {text:'FIRMA Y SELLO :\n', bold:true},
                                        {text:'\n'},
                                        {text:'\n'},

                                      ]
                                  },{},

                                ], //end row17


                            ], //table end body
                          }
                        }, //Obj2.columns.First Column End columns

                      ] //obj 2 end Columns

                }, //End obj2

              //Separador
            { text: ' ', margin: [0, 10, 0, 10] },

          ] }
          ],

          styles: {
            header: {
              fontSize: 18,
              bold: true,
              margin: [0, 0, 0, 10]
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5]
            },
            tableExample: {
              margin: [0, 5, 0, 15]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
          }
        }




  }


//#endregion print

}
